import styles from "./Hero.module.css";
import heroImage from "../assets/landing.JPG"; // replace with your photo

export default function Hero() {
  return (
    <section className={styles.hero}>
      <div className={styles.imageWrapper}>
        <div className={styles.bgBlockLeft}></div>
        <div className={styles.bgBlockRight}></div>

        <img src={heroImage} alt="Milagros Casaperalta" className={styles.heroImage} />
      </div>

      <h1 className={styles.title}>Software developer</h1>
      <p className={styles.nameBehind}>Milagros Casaperalta</p>
    </section>
  );
}


